export default __webpack_public_path__ + "static/media/guide-to-reimbursable-dependent-care-expenses.cda70fa0.svg";